export const EventLayout = (props) => {
  return (
    <div className="w-full m-0">
      <>{props.children}</>
    </div>
  );
};
